import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './general-health.reducer';

export const GeneralHealthDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const generalHealthEntity = useAppSelector(state => state.generalHealth.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="generalHealthDetailsHeading">
          <Translate contentKey="apiLocationApp.generalHealth.detail.title">GeneralHealth</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.generalHealth.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.generalHealth.date">Date</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.generalHealth.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.generalHealth.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.generalHealth.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="veryGoodHealth">
              <Translate contentKey="apiLocationApp.generalHealth.veryGoodHealth">Very Good Health</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.veryGoodHealth}</dd>
          <dt>
            <span id="goodHealth">
              <Translate contentKey="apiLocationApp.generalHealth.goodHealth">Good Health</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.goodHealth}</dd>
          <dt>
            <span id="fairHealth">
              <Translate contentKey="apiLocationApp.generalHealth.fairHealth">Fair Health</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.fairHealth}</dd>
          <dt>
            <span id="badHealth">
              <Translate contentKey="apiLocationApp.generalHealth.badHealth">Bad Health</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.badHealth}</dd>
          <dt>
            <span id="veryBadHealth">
              <Translate contentKey="apiLocationApp.generalHealth.veryBadHealth">Very Bad Health</Translate>
            </span>
          </dt>
          <dd>{generalHealthEntity.veryBadHealth}</dd>
        </dl>
        <Button tag={Link} to="/general-health" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/general-health/${generalHealthEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GeneralHealthDetail;
